import { useAppStore } from '../../store/useAppStore';
import styles from './CaptureOverlay.module.css';

/**
 * Sperrscheibe und Beschriftung während des Bogenabzugs.
 *
 * **Zwei Aufgaben in einem Bauteil:**
 *
 * 1. Die **Scheibe** fängt jede Berührung ab. Während des Abzugs scrollt der Bogen unter der
 *    Hand weg; ein Häkchen, das dabei gesetzt wird, landete auf einer Aufgabe, die der
 *    Prüfer gar nicht sieht. Sie ist durchsichtig — sie soll sperren, nicht das Bild
 *    verdunkeln, das gerade aufgenommen wird.
 * 2. Der **Streifen** unten trägt Gerät, Uhrzeit, Station, Prüfer und Prüfling. Er steht auf
 *    **jeder** Kachel, weil jede für sich zuordenbar sein muss: wer eine einzelne Aufnahme
 *    aus dem Ordner zieht, soll ohne Dateinamen und ohne Begleitdatei wissen, woher sie
 *    stammt.
 *
 * ⚠️ Der Streifen ist Teil des Bildes, nicht der Beglaubigung. Er ist lesbar, nicht
 * fälschungssicher — dafür ist die `.sig` da. Beides zusammen: man sieht es und kann es
 * prüfen.
 */
export function CaptureOverlay() {
  const beschriftung = useAppStore((s) => s.shotStamp);
  if (beschriftung === null) return null;

  return (
    <div className={styles.pane} aria-hidden="true">
      <div className={styles.stamp}>{beschriftung}</div>
    </div>
  );
}
